import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../state/AuthContext';

/**
 * Gate for any route that requires *some* signed-in user (not just admin).
 * Sends signed-out visitors to /sign-in carrying the original destination.
 *
 * Local dev: AuthContext falls back to "always signed in" when /api/auth/me
 * is unreachable, so /me + /admin still work for build-time persona flows.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isSignedIn, authReady } = useAuth();
  const location = useLocation();

  if (!authReady) return null;
  if (!isSignedIn) {
    return <Navigate to="/sign-in" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
